import { IBackgroundData } from "./background-data";
import { IPxHeightData } from "./height-data";
import { IBorderRadiusData, IElementWithLink, IWidgetData, IWidgetVisibility, LinkData, SelfPosition, VisibilityData } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface IBoxWidgetData extends IElementWithLink, IWidgetVisibility, IWidgetContainer {
    readonly type: "BoxWidget";
    readonly placeType: "Section";
    id?: string | null;
    hoverStateType?: HoverStateType;
    regularStateData: IWidgetContentData;
    hoverStateData: IWidgetContentData;
    isStateDuplicated?: boolean;
}

export interface IWidgetContentData {
    background: IBackgroundData;
    style: IBoxWidgetStyle;
}

export interface IBoxWidgetStyle extends IAnimatedWidget {
    displayShadow?: boolean | null;
    shadowColor?: string;
    borderRadius?: IBorderRadiusData;
    borderColor?: string | null;
    thickness?: number | null;
    heightData?: IPxHeightData | null;
    padding?: number | null;
    verticalAlignment: SelfPosition;
}

export interface IWidgetContainer {
    childWidgets?: IWidgetData[]; // filled only for cascade rendering, otherwise is undefined
    hoverChildWidgets?: IWidgetData[]; // filled only for cascade rendering, otherwise is undefined
}

export abstract class BoxWidgetData {

    public static get defaultStyle(): IBoxWidgetStyle {
        return {
            displayShadow: true,
            shadowColor: "rgba(32, 32, 32, 0.2)",
            verticalAlignment: "center",
            borderRadius: {
                topLeftPx: 0,
                topRightPx: 0,
                bottomLeftPx: 0,
                bottomRightPx: 0
            },
            borderColor: "#888888",
            thickness: 0,
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            },
            heightData: {
                height: 64
            },
            padding: 12
        };
    }

    public static get defaultData(): IBoxWidgetData {
        return {
            type: "BoxWidget",
            placeType: "Section",
            hoverStateType: "none",
            visibility: VisibilityData.defaultData(),
            childWidgets: [],
            hoverChildWidgets: [],
            linkData: LinkData.noneData,
            regularStateData: {
                style: this.defaultStyle,
                background: {
                    mediaBackground: null,
                    style: {
                        color: "rgb(255, 255, 255)"
                    }
                }
            },
            hoverStateData: {
                style: this.defaultStyle,
                background: {
                    mediaBackground: null,
                    style: {
                        color: "rgb(255, 255, 255)"
                    }
                }
            },
        };
    }

    public static updateWithDefaultsHover(data: IBoxWidgetData): void {
        data.hoverStateData = {
            style: BoxWidgetData.defaultData.hoverStateData.style,
            background: BoxWidgetData.defaultData.hoverStateData.background
        };
    }

    public static localScriptRerenderNeeded(leftHandSide?: IBoxWidgetData, rightHandSide?: IBoxWidgetData): boolean {
        return leftHandSide?.id === rightHandSide?.id &&
            leftHandSide?.hoverStateType === rightHandSide?.hoverStateType &&
            leftHandSide?.regularStateData.style.heightData === rightHandSide?.regularStateData.style.heightData;
    }

}

export type HoverStateType = "none" | "regular" | "hover";
